// extracted by mini-css-extract-plugin
export default {"nomal-input":"SHhXBFhwPAASDeoIwCWM","diable-input":"PuqKYhekYAU1uQVsdsJ3"};